export default "__VITE_ASSET__CQI1bYTQ__"